import tournamentCatalogRoutes from '../modules/catalog/routes'
import tournamentRoutes from '../modules/tournament/routes'
import instantMatchRoutes from '../modules/instant/routes'
import matchRoomRoutes from '../modules/match/routes'
import authRoutes from '../modules/auth/routes'
import memberRoutes from '../modules/member/routes'
import paymentRoutes from '../modules/payment/routes'

export default {
  path: '/',
  component: () =>
    import(
      /* webpackChunkName: "app-layout" */ '@/modules/shared/AppLayout.vue'
    ),
  children: [
    tournamentCatalogRoutes,
    tournamentRoutes,
    instantMatchRoutes,
    matchRoomRoutes,
    memberRoutes,
    paymentRoutes,
    ...authRoutes
  ]
}

export const inviteRoute = {
  path: '/invite/:inviteToken',
  name: 'PublicInviteToken',
  props: true,
  component: () =>
    import(
      /* webpackChunkName: "invite" */ '@/modules/shared/views/InviteToken'
    ),
  meta: {
    title: '接受隊伍邀請'
  }
}

export const tournamentBracketRoute = {
  path: '/bracket/:tournamentId',
  name: 'TournamentBracket',
  props: true,
  component: () =>
    import(
      /* webpackChunkName: "tournament-bracket" */ '@/modules/tournament/views/TournamentBracket'
    ),
  meta: {
    title: '賽程表'
  }
}

export const tournamentFormRoutes = {
  path: '/tournament-form/:tournamentId',
  name: 'TournamentForm',
  props: true,
  component: () =>
    import(
      /* webpackChunkName: "tournament-form" */ '@/modules/tournament/views/TournamentForm'
    ),
  meta: {
    title: 'Form Response'
  }
}
